module.exports = __webpack_public_path__ + "img/cardtonic.com.png.545bdef1.webp";